export default {
  name: {
    id: 'rm_metal_cobalt_name',
    defaultMessage: 'Cobalt',
  },
  smartphoneLabel: {
    id: 'rm_metal_cobalt_smartphone_label',
    defaultMessage: 'Several grams',
  },
  whatItDoesText: {
    id: 'rm_metal_cobalt_what_it_does',
    defaultMessage:
      'Cobalt is a metallic element and an essential component of almost all mobile phone batteries.',
  },
  extractionText1: {
    id: 'rm_metal_cobalt_extraction_p1',
    defaultMessage:
      "Cobalt is a by-product, usually found alongside copper and nickel deep underground. Extracting it relies on two very different methods: industrial open-pit mines, which use heavy machinery to break through the earth and pull up the minerals; and artisanal mines, where workers dig by hand with crude tools, with little protective equipment. Artisanal mines account for 10-20% of production in the Democratic Republic of Congo (DRC), the world's main cobalt supplier.",
  },
  extractionText2: {
    id: 'rm_metal_cobalt_extraction_p2',
    defaultMessage:
      'Regardless of how it is extracted, most cobalt ore is shipped to China, which refines more than 75% of global supply, into pure cobalt used in your phone or electric vehicle (EV) battery.',
  },
  quickFactText: {
    id: 'rm_metal_cobalt_quick_fact',
    defaultMessage:
      'The cobalt in your phone could be mined by a child as young as 6.[^*]',
  },
  envSummaryText: {
    id: 'rm_metal_cobalt_env_summary',
    defaultMessage:
      "Most of the world's cobalt is extracted through open-pit or large-scale underground mining, which destroys natural habitats, generates pollution and sometimes displaces local communities. The rest comes from small-scale artisanal mines, which often operate with few or no regulations, or environmental oversight. Both types of mines can leach toxins into soil and water, and carcinogenic particles into the air, undermining the long-term health of people, animals, and ecosystems.",
  },
  envWaterText: {
    id: 'rm_metal_cobalt_env_water_text',
    defaultMessage:
      'Cobalt extraction can trigger acid mine drainage, which leaches highly acidic water loaded with arsenic, cadmium, and mercury into streams and groundwater, potentially spreading contamination across entire river basins. An estimated 23 million people worldwide are exposed to dangerous concentrations of toxic waste along riverbanks as a direct result of metal extraction and processing.',
  },
  envSoilText: {
    id: 'rm_metal_cobalt_env_soil_text',
    defaultMessage:
      'Cobalt mines often emit heavy metals into the environment through dust, leaking tailing dams, and smelter emissions. These toxins can persist in soils for many years, entering the food chain through crops and drinking water. Without rehabilitation, contamination can continue for hundreds of years after a mine closes. An estimated 11 million people worldwide are already affected by closed and abandoned mines.',
  },
  envBiodiversityText: {
    id: 'rm_metal_cobalt_env_biodiversity_text',
    defaultMessage:
      'Building a mine inevitably involves destroying natural habitats, which threatens wildlife. Mining can also bring roads and development into remote areas, making it easier for farming, logging, and hunting to expand. As high-quality mineral deposits become harder to find, larger areas of land must be disturbed to produce the same amount of metal, increasing environmental damage. If current trends continue, biodiversity threats from cobalt mining could surge by 500-900% by 2050.',
  },
  envClimateText: {
    id: 'rm_metal_cobalt_env_climate_text',
    defaultMessage:
      "Cobalt mining depends heavily on fossil fuels for land clearing, transportation, and the energy-intensive smelting of sulfide ores. As the richest sources of cobalt run out, mining companies have to use more energy to extract the same amount of metal. This increases the amount of greenhouse gases produced. Overall, mining and processing metals are responsible for about 10% of the world's energy-related greenhouse gas emissions.",
  },
  humanSummaryText: {
    id: 'rm_metal_cobalt_human_summary',
    defaultMessage:
      'Child labour. Forced labour. Chronic disease. Cobalt is associated with some of the best-documented human rights abuses in the global mining industry, and yet demand keeps growing. Around 75% of global cobalt comes from the DRC, where artisanal mining (unregulated, hand-dug work with little safety protection) is widespread. Entire families are exposed to toxic dust and radioactive materials while earning pennies.',
  },
  humanDisplacementText: {
    id: 'rm_metal_cobalt_human_displacement_text',
    defaultMessage:
      'Expanding mines have evicted many local people from their homes in the DRC. Meanwhile, land allocated for cobalt mining has reduced the areas available for hunting and farming. In 2022 alone, tens of thousands of people were evicted after cobalt was discovered near the city of Kolwezi. Communities rarely receive adequate compensation.',
  },
  humanHealthText: {
    id: 'rm_metal_cobalt_human_health_text',
    defaultMessage:
      'Cobalt mining can pollute air, water, and soil. Mines have contaminated local populations with heavy metals. Exposure to cobalt itself can damage the heart, thyroid, lungs, and skin. Cobalt mining can also generate tumours, respiratory problems, metabolic disorders, genetic deformations, sterility, and burning sensations in the eyes and throat. Risks are highest in artisanal mining, where workers typically operate without protective equipment day-after-day.',
  },
  humanChildLabourText: {
    id: 'rm_metal_cobalt_human_child_labour_text',
    defaultMessage:
      'The artisanal sector (roughly 10-20% of DRC cobalt production) is rife with dangerous conditions, child labour, and corruption. Thousands of children, some as young as 6, work in Congolese cobalt mines, breathing hazardous dust, hauling heavy loads and at constant risk of a beating. Under pressure from consumers, some large companies have cut Congolese artisanally mined cobalt from their supply chains. But this approach threatens the livelihoods of 200,000 workers and risks exacerbating poverty and instability. A better approach might be trying to improve conditions.',
  },
  humanGenderText: {
    id: 'rm_metal_cobalt_human_gender_text',
    defaultMessage:
      'Up to half of the artisanal mining workforce in the DRC is women, yet discrimination is rampant. Women are often assigned the worst tasks such as digging in extreme weather, are paid less, and often work unlawful hours. In remote mining areas where legal safeguards are least developed and least enforced, they face heightened gendered violence, including sexual assault.',
  },
  humanLegalText: {
    id: 'rm_metal_cobalt_human_legal_text',
    defaultMessage:
      'Human rights abuses span both industrial and artisanal mining: forced evictions, forced labor, and widespread environmental damage in industrial operations; child labour, health hazards, and corruption in artisanal mining. Weak governance and absent oversight make abuse structural. Miners pay bribes to access sites; politically connected figures control cooperatives. Despite regulations on paper, artisanal mining on the ground remains almost entirely uncontrolled. Chinese companies own 8 of the 14 largest cobalt mines in the DRC, often relying on cheap expatriate labour rather than investing locally, leaving communities to absorb the human cost of a market they have no power over.',
  },
  geoSummaryText: {
    id: 'rm_metal_cobalt_geo_summary',
    defaultMessage:
      "Cobalt is in every rechargeable battery, your smartphone, your laptop, your electric car. And the world's supply hangs by a thread. The cobalt supply chain is essentially a two-stop shop: the DRC mines it, and China refines it. Until cobalt-free batteries become more widely available, that concentration makes these two countries the gatekeepers of price and supply.",
  },
  geoDugText: {
    id: 'rm_metal_cobalt_geo_dug_text',
    defaultMessage:
      'One country mines the vast majority of cobalt: the Democratic Republic of the Congo, with 75.9% of global cobalt resources being mined there.',
  },
  geoProcessedText: {
    id: 'rm_metal_cobalt_geo_processed_text',
    defaultMessage:
      "One country has for years refined about three-quarters of the world's supply: China.",
  },
  geoLeverageText: {
    id: 'rm_metal_cobalt_geo_leverage_text',
    defaultMessage:
      'The danger of this concentration became apparent in early 2025, when the DRC announced a four-month suspension of cobalt exports to counter falling prices. Following the announcement, cobalt prices rose sharply, reaching a peak in March, when they were 67% higher than at the time of the announcement. No geological shortage, no technical failure. Just one political decision, and the entire global supply chain was shaken.',
  },
  supplySummaryText: {
    id: 'rm_metal_cobalt_supply_summary',
    defaultMessage:
      "Right now, there is enough cobalt to go around. But not necessarily for long. From 2030, the DRC's mines will start producing less just as demand keeps rising. New battery types that use less cobalt exist but they won't be widespread soon enough to fill the gap.",
  },
  supplyReservesText: {
    id: 'rm_metal_cobalt_supply_reserves_text',
    defaultMessage:
      "The mines that produce most of the world's cobalt are in the Democratic Republic of Congo. As the richest deposits are used up, production is expected to start falling after 2030. By 2040, the world could be short of 50,000 tonnes of cobalt per year.",
  },
  supplyDemandText: {
    id: 'rm_metal_cobalt_supply_demand_text',
    defaultMessage:
      'Cobalt demand is expected to grow by as much as 55% by 2050, driven largely by the global shift to electric vehicles.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_cobalt_recycling_summary',
    defaultMessage:
      'Cobalt is recycled more than some metals, but it is a partial system: it works in some sectors but not all, and not yet at scale. Small batteries like those found in smartphones, for instance, are very difficult to recycle profitably. Currently, over 40% of the cobalt in battery waste is successfully recovered. But most EV batteries are still in use, so the volumes available to recycle are relatively small.',
  },
  recyclingInputText: {
    id: 'rm_metal_cobalt_recycling_input_text',
    defaultMessage:
      'Recycled scrap from end-of-life products currently provides about 12% of the cobalt fed into the production system, meaning nearly all new supply still comes from freshly mined ore.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_cobalt_recycling_outlook_text',
    defaultMessage:
      'By 2050, recycling could reduce the need for newly mined cobalt by up to 40%. But it will never replace mining entirely. For many years to come, the world will still depend on the DRC and China for the cobalt that powers our devices.',
  },
  footnote1Text1: {
    id: 'rm_metal_cobalt_footnote_1_p1',
    defaultMessage:
      'ADEME (2024) estimates that artisanal and informal mining accounts for approximately 10–20% of global cobalt production. Child labour has been documented in some of these mines.',
  },
  footnote1Text2: {
    id: 'rm_metal_cobalt_footnote_1_p2',
    defaultMessage:
      'The presence of child labour in Congolese cobalt mining has also been documented by multiple studies and investigations, including the following sources:',
  },
  footnote1Text3: {
    id: 'rm_metal_cobalt_footnote_1_p3',
    defaultMessage:
      'Siddharth Kara, an adjunct lecturer at Harvard Kennedy School, a visiting scientist at Harvard School of Public Health, and the author of Cobalt Red, reported in a 2018 article for The Guardian: “Based on the data I gathered, I estimate there are more than 255,000 creuseurs mining cobalt in DRC, at least 35,000 of whom are children, some as young as six.” Siddharth Kara, “Is your phone tainted by the misery of the 35,000 children in Congo’s mines?,” The Guardian, 12 October 2018, [https://www.theguardian.com/global-development/2018/oct/12/phone-misery-children-congo-cobalt-mines-drc](https://www.theguardian.com/global-development/2018/oct/12/phone-misery-children-congo-cobalt-mines-drc).',
  },
  footnote1Text4: {
    id: 'rm_metal_cobalt_footnote_1_p4',
    defaultMessage:
      'Nicolas Niarchos, “Inside the Brutal Center of Copper and Cobalt Mining in the Congo,” Literary Hub, 22 January 2026, [https://lithub.com/inside-the-brutal-center-of-copper-and-cobalt-mining-in-the-congo/](https://lithub.com/inside-the-brutal-center-of-copper-and-cobalt-mining-in-the-congo/).',
  },
  mine0Region: {
    id: 'rm_metal_cobalt_mine0_region',
    defaultMessage: 'Tenke Fungurume',
  },
  mine1Region: {
    id: 'rm_metal_cobalt_mine1_region',
    defaultMessage: 'Mutanda & Kamoto',
  },
  mine2Region: {
    id: 'rm_metal_cobalt_mine2_region',
    defaultMessage: 'Norilsk-Talnakh',
  },
  mine3Region: {
    id: 'rm_metal_cobalt_mine3_region',
    defaultMessage: 'Murrin Murrin',
  },
} as const
